import { requestServerApi, serverApi } from "../../api/api";

const useFile = () => {
  const handleDownload = async (fileUrl: string) => {
    try {
      const result = await requestServerApi<any>(() =>
        serverApi.lessonControllerGetDownloadUrl(fileUrl)
      );
      if (result.data.code !== 200) {
        throw new Error(result.data.message || 'Failed to get download URL');
      }
      const presignedUrl = result.data.data[0]?.presignedUrl;
      if (!presignedUrl) {
        throw new Error('Presigned URL not found');
      }
      window.open(presignedUrl, '_blank'); // opens presigned URL — browser auto-downloads
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return { handleDownload };
};

export default useFile;